import React, { useEffect } from 'react'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'
import Show from './show'
import List from './List'

const History: React.FC = ({}) => {
  const { path } = useRouteMatch()

  return (
    <>
      <Switch>
        <Route path={path + '/:id'}>
          <Show />
        </Route>
        <Route path={path + '/'}>
          <List />
        </Route>
        <Redirect from={path} to={path + '/'} />
      </Switch>
    </>
  )
}

export default History
